import { OnInit, OnDestroy } from '@angular/core';
import { Component } from '@angular/core';
import { IContextService } from '@pershing/pershing-core';
import { DomainContext } from '@pershing/pershing-core';
import { Subscription } from 'rxjs';
import { PershingTranslationService } from '@pershing/pershing-core';
import { NxiRestService } from '../../services/NXI-Rest.service';
import { NxiWidgetParamsService } from '../../services/NXI-WidgetParams.service';
import { NxiContextUtils } from '@pershing/nxi-common';

declare let dojoApp: any;

@Component({
    selector: 'dojo-history-summary',
    templateUrl: './dojo-portfolio-history.component.html'
})
export class DojoPortfolioHistoryComponent implements OnInit, OnDestroy {
    inputValue: string = '';
    domain: string = '';
    subs: Subscription;
    acctRef: any;
    constructor(private contextService: IContextService, private translationService: PershingTranslationService,
                private nxiRestService: NxiRestService,
                private nxiWidgetParamsService: NxiWidgetParamsService) {
        this.translationService.addTranslationFolder('@pershing/nxi-ng-portfolio', 'node_modules/@pershing/nxi-ng-portfolio/lib');
    }

    ngOnInit() {
        this.subs = this.contextService.selectedDomainContext$.subscribe((domainContext: DomainContext<any>) => {
            let contextValue = NxiContextUtils.getContextFromDomainValue(domainContext);
            this.inputValue = contextValue.inputValue;
            this.acctRef = contextValue.hashValue;
            this.getPortfolioHistory();
        });
    }

    ngOnDestroy(): void {
        if (this.subs) {
            this.subs.unsubscribe();
        }
        if (dojoApp) {
            dojoApp.destroyPortFolioHistorySummary('tradingOverview');
        }
    }
    renderDojoWidget(PortfolioHistoryDojoParams: any) {
        if (dojoApp) {
            // pass necessary parameters to render dojo widgets
            dojoApp.renderPortFolioHistorySummary(this.inputValue, PortfolioHistoryDojoParams);
        }
    }
    getPortfolioHistory() {
        if (this.inputValue !== '' && this.acctRef !== '') {
            this.nxiWidgetParamsService.getWidgetParams(this.acctRef, 'activitySummary').subscribe(
                resp => {
                    console.log('Retrived common REST Portfolio History params : ', resp.response);
                    if (resp.response) {
                        resp.response.storeUrl = this.nxiRestService.serviceUrl + resp.response.storeUrl;
                        resp.response.modAPIUrl = 'https://api-netxselect.wsodqa.com';
                        this.renderDojoWidget(resp.response);
                    }
                }
            );
        }
    }

    gotoRoute(page: string): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail:
            {
                'gotoPage': page

            }
        }));
    }

}
